// extracted by mini-css-extract-plugin
module.exports = {"caption2":"solutions2_caption2__1T9hI","container":"solutions2_container__134bO"};